import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorMessage } from '@sc/data-access-models';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-error',
  styleUrls: ['./error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatFormFieldModule, IconComponent],
  template: `
    <mat-error
      [id]="id"
      [attr.aria-atomic]="undefined"
      [attr.aria-live]="undefined"
      class="sc-mat-error"
      *ngIf="displayCondition && (!!error?.title || !!error?.message)"
    >
      <sc-icon name="alert"></sc-icon>
      <div class="textual_content">
        <p class="sc-design-text-4 title_error">
          {{ error?.title }}
        </p>
        <p class="sc-design-text-3 text_error" [innerHTML]="error?.message"></p>
      </div>
    </mat-error>
  `,
})
export class ErrorComponent {
  @Input() id: string;
  @Input() displayCondition = false;
  @Input() error: ErrorMessage;
}
